import { createContext } from 'react'
import type { Goal, SubTask, Task } from '../types/timeline'

export interface DataContextValue {
  goals: Goal[]
  hasUnsavedAnonymousTimeline: boolean
  dismissAnonymousTimelineWarning: () => void
  addGoal: (newGoal: Goal) => void
  updateGoal: (goalId: string, updatedGoal: Partial<Goal>) => void
  deleteGoal: (goalId: string) => void
  addTask: (goalId: string, newTask: Task) => void
  updateTask: (goalId: string, taskId: string, updatedTask: Partial<Task>) => void
  deleteTask: (goalId: string, taskId: string) => void
  addSubTask: (goalId: string, taskId: string, newSubTask: SubTask) => void
  updateSubTask: (
    goalId: string,
    taskId: string,
    subTaskId: string,
    updatedSubTask: Partial<SubTask>,
  ) => void
  deleteSubTask: (goalId: string, taskId: string, subTaskId: string) => void
}

export const DataContext = createContext<DataContextValue | undefined>(undefined)
